/**
 * A hook that provides the currently selected language, supportedLangugages, and a callback to switch languages.
 *
 * @module
 */
import { getSupoportedLanguages as getSupoportedLanguagesFromWindow, getLanguageId, } from '../utils/globals';
/**
 * Change the currently selected language of a KB
 */
function changeLanguage(languageId) {
    window.location.assign(`/${languageId}`);
}
function getSupportedLanguages({ showAnglicisedSuffix, }) {
    const windowLanguages = getSupoportedLanguagesFromWindow() || [];
    const supportedLanguages = windowLanguages.map((lang) => {
        const label = lang.id === 'en'
            ? lang.nativeName
            : showAnglicisedSuffix
                ? `${lang.nativeName} (${lang.englishName})`
                : lang.nativeName;
        const supportedLanguage = {
            id: lang.id,
            iconPath: getIconPath(lang.id),
            label,
        };
        return supportedLanguage;
    });
    return supportedLanguages;
}
/**
 * Gets the path of a flag icon for a supported language
 */
function getIconPath(languageId) {
    return `https://cdn.elev.io/kb/assets/flags/${languageId}.svg`;
}
/**
 * # useLanguages
 */
export function useLanguages({ showAnglicisedSuffix } = {
    showAnglicisedSuffix: false,
}) {
    const supportedLanguages = getSupportedLanguages({ showAnglicisedSuffix });
    const selectedLanguageId = getLanguageId();
    const selectedLanguageIndex = supportedLanguages.findIndex((language) => selectedLanguageId === language.id);
    if (selectedLanguageIndex < 0)
        throw new Error('useLanguages > Invalid language selected');
    const selectedLanguage = supportedLanguages[selectedLanguageIndex];
    const setCurrentLanguageId = (languageId) => {
        if (languageId !== selectedLanguageId)
            changeLanguage(languageId);
    };
    return {
        supportedLanguages,
        selectedLanguage,
        setCurrentLanguageId,
    };
}
//# sourceMappingURL=useLanguages.js.map